import { cn } from '@workspace/ui/lib/utils';
import { ReactNode } from 'react';

interface TileProps {
  children?: ReactNode;
  onClick?: () => void;
  className?: string;
  isAddContentButton?: boolean;
  disableHover?: boolean;
  isMyProfile: boolean;
}

export const EmptyTileWrapper = ({
  children,
  className,
  onClick,
  disableHover = false,
  isMyProfile = false,
}: TileProps) => {
  return (
    <>
      {isMyProfile && (
        <div
          onClick={onClick}
          className={cn(
            'relative flex items-center justify-center h-full w-full transition-colors cursor-pointer text-gray-text group',
            className
          )}
        >
          {!disableHover && (
            <svg
              className="absolute inset-0 w-full h-full"
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
            >
              <rect
                x="1"
                z="0"
                y="1"
                width="98"
                height="98"
                rx="6"
                ry="6"
                fill="none"
                stroke="#d1d5db"
                strokeWidth="0.5"
                strokeDasharray="6 6"
                strokeDashoffset="16"
              />
            </svg>
          )}
          <div
            className={cn(
              'z-10 flex w-full h-full items-center justify-center transform transition-all duration-200 ease-in-out',
              {
                'hover:rounded-lg hover:bg-bg-gray w-[calc(100%-16px)] h-[calc(100%-16px)]':
                  !disableHover,
              }
            )}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
};
